export const detailUrl = ({ id }) => {
  return `/portfolios/${id}`;
};
export const constructStrRep = (obj) => {
  return obj.title;
};
